module.exports = __webpack_public_path__ + "static/media/timer-bg-image.ba9c7172.png";